import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import SeverityOfAlertsChart from "./SeverityOfAlertsChart";
import AutoResolvedChart from "./AutoResolvedChart";
import TriggeredAlertBreakdownChart from "./TriggeredAlertBreakdownChart";
import ResolutionDurationBreakdownChart from "./ResolutionDurationBreakdownChart";
import { calculateGranularity } from "../../BmsFaults/CommonFunctions";
import { CHART_TYPES } from "./chartConfig";

const SmartAlertsTrends = ({ onShowDetails, startDate, endDate, globalFilters = {} }) => {
  const granularity = calculateGranularity(startDate, endDate);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <Box>
        <Typography variant="fw400s20c000" sx={{ lineHeight: "28px", fontWeight: 300 }}>
          Smart Alert Trends
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <SeverityOfAlertsChart
          onDetailsClick={() => onShowDetails(CHART_TYPES.SEVERITY, granularity)}
          startDate={startDate}
          endDate={endDate}
          globalFilters={globalFilters}
        />
        <AutoResolvedChart
          onDetailsClick={() => onShowDetails(CHART_TYPES.AUTO_RESOLVED, granularity)}
          startDate={startDate}
          endDate={endDate}
          globalFilters={globalFilters}
        />
      </Box>

      <Divider sx={{ my: 2, borderColor: "#E6E6E6" }} />

      <Box>
        <Typography variant="fw400s20c000" sx={{ lineHeight: "28px", fontWeight: 300 }}>
          Insights
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TriggeredAlertBreakdownChart
          startDate={startDate}
          endDate={endDate}
          globalFilters={globalFilters}
        />
        <ResolutionDurationBreakdownChart
          startDate={startDate}
          endDate={endDate}
          globalFilters={globalFilters}
        />
      </Box>
    </Box>
  );
};

export default SmartAlertsTrends;
